var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecibidas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.319824,
    y: 0.563477,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#F4ECDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7197 15.7635C10.7197 15.127 10.9726 14.5166 11.4227 14.0665C11.8728 13.6164 12.4832 13.3635 13.1197 13.3635H19.1197L21.5197 15.7635H27.5197C28.1562 15.7635 28.7667 16.0164 29.2168 16.4665C29.6669 16.9166 29.9197 17.527 29.9197 18.1635V25.3635C29.9197 26 29.6669 26.6105 29.2168 27.0606C28.7667 27.5107 28.1562 27.7635 27.5197 27.7635H13.1197C12.4832 27.7635 11.8728 27.5107 11.4227 27.0606C10.9726 26.6105 10.7197 26 10.7197 25.3635V15.7635Z",
    fill: "#FFAD05"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecibidas);
export default __webpack_public_path__ + "static/media/recibidas.300afa90d426659ed04a06d6fe679ff8.svg";
export { ForwardRef as ReactComponent };